// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Search from "@insite/mobius/Icons/Search";
import { searchFieldProductNumberStyles } from "@werner/Overrides/Widgets/MyLists/MyListsSearchFieldProductNumber";
import { css } from "styled-components";

searchFieldProductNumberStyles.wrapper = {
    wrapper: {
        css: css`
            padding: 0;
            width: 100%;
            position: relative;
        `,
    },
};

searchFieldProductNumberStyles.clearIcon = {
    size: 14,
    css: css`
        position: absolute;
        right: 50px;
        top: 28px;
        cursor: pointer;
    `,
};

searchFieldProductNumberStyles.searchDynamicDropdown = {
    cssOverrides: {
        selectedText: css`
            padding: 28px 42px 9px 11px;
        `,
    },
    iconProps: {
        src: Search,
    },
};
